import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface PhoneInIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const PhoneInIcon: React.FC<PhoneInIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon phone-in')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512">
        <path d="M493.1 351.2L384.6 304.7c-12.78-5.531-27.8-1.812-36.48 8.969l-44.05 53.81c-69.25-34-125.5-90.28-159.5-159.5l53.83-44.09c10.75-8.781 14.42-23.66 8.984-36.44L160.8 18.93C154.7 5.027 139.7-2.598 124.1 .8079L24.22 24.06C9.969 27.31 0 39.84 0 54.5C0 306.8 205.2 512 457.5 512c14.67 0 27.2-9.969 30.47-24.22l23.25-100.8C514.6 372.4 507 357.2 493.1 351.2zM320 224h96c17.67 0 32-14.33 32-32s-14.33-32-32-32h-18.75l105.4-105.4c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0L352 114.8V96c0-17.67-14.33-32-32-32s-32 14.33-32 32v96C288 209.7 302.3 224 320 224z" />
      </svg>
    </Tooltip>
  );
};
